export default "__VITE_ASSET__ChoVT9l6__"